module.exports = __webpack_public_path__ + "static/media/tourisme.9009401c.png";